"use client"

import { useState } from "react"
import { useLanguage } from "../../context/LanguageContext"
import { Globe, ChevronDown } from "lucide-react"

const SimpleLanguageSwitcher = () => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage()
  const [isOpen, setIsOpen] = useState(false)

  const currentLang = availableLanguages.find((lang) => lang.code === currentLanguage) || availableLanguages[0]

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode)
    setIsOpen(false)
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 text-white hover:text-blue-200 transition-colors"
      >
        <Globe size={18} />
        <span className="hidden md:inline">
          {currentLang.flag} {currentLang.name}
        </span>
        <span className="md:hidden">{currentLang.flag}</span>
        <ChevronDown size={16} className={`transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />

          {/* Dropdown */}
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border">
            {availableLanguages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center space-x-2 transition-colors ${
                  currentLanguage === language.code ? "bg-blue-50 text-blue-600" : "text-gray-700"
                }`}
              >
                <span>{language.flag}</span>
                <span>{language.name}</span>
                {currentLanguage === language.code && <span className="ml-auto text-blue-600">✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default SimpleLanguageSwitcher
